import { alpha, makeStyles, TextField, withStyles } from "@material-ui/core";

export const StyledTextField = withStyles((theme) => ({
  root: {
    marginRight: theme.spacing(3),
    display: "inline-flex",
    flex: 1,
    "& .MuiInputLabel-formControl": {
      color: theme.custom.color.pewter,
      fontWeight: 600,
      fontSize: "14px",
    },
    "& .MuiInputLabel-formControl .MuiInputLabel-asterisk": {
      display: "none",
    },
    "& .MuiInputLabel-formControl.Mui-focused": {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    "& .MuiInputBase-root:before": {
      borderColor: theme.custom.color.gainsboro,
      borderWidth: "1px",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderColor: theme.custom.color.gainsboro,
      borderWidth: "1px",
    },
    "& .MuiSvgIcon-root": {
      color: theme.custom.color.pewter,
    },
  },
}))(TextField);

export const useStyles = makeStyles((theme) => ({
  tableHeader: {
    marginBottom: theme.spacing(2),
  },
  tableFilter: {
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.15),
    borderRadius: "8px",
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2),
  },
  filterBox: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: "space-between",
    "& .MuiButton-outlined": {
      borderRadius: "24px",
      minWidth: "114px",
      borderWidth: "2px",
      display: "inline-flex",
      "& .MuiButton-label": {
        fontSize: "14px",
        fontWeight: 700,
      },
    },
  },
  search: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& .MuiSvgIcon-root, & .MuiTextField-root": {
      display: "flex",
    },
    "& .MuiFormLabel-root:not(.MuiFocussed)": {
      color: theme.custom.color.mortar,
      fontSize: "14px",
    },
    "& .MuiInput-root": {
      "&:before, &:after": {
        display: "none",
      },
    },
    "& .MuiSvgIcon-root": {
      margin: theme.spacing(2, 1, 0, 0),
      transform: "scaleY(-1) rotate(180deg)",
      color: theme.custom.color.mortar,
    },
  },
  btnGrp: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  rotate: {
    transform: "rotate(180deg)",
    color: theme.custom.color.mortar,
  },
  rotateScale: {
    transform: "scaleY(-1) rotate(180deg)",
    color: theme.custom.color.mortar,
  },
  dataWrapper: {
    height: 650,
  },
  filterBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    margin: theme.spacing(2.5, 0, 1, 0),
  },
  dataGrid: {
    border: "none",
    "& .MuiDataGrid-menuIcon": {
      display: "none",
    },
    "& .MuiDataGrid-window": {
      "& .MuiDataGrid-row": {
        "&:hover": {
          backgroundColor: "transparent",
        },
        "& .MuiDataGrid-cell": {
          "&:focus": {
            outline: "none",
          },
          "&:first-child": {
            fontWeight: 700,
          },
          "&.noBold": {
            fontWeight: 400,
          },
          "&.bold": {
            fontWeight: 700,
          },
          "&.breakWord": {
            textOverflow: "inherit",
            overflow: "visible",
            wordBreak: "break-all",
          },
        },
      },
    },
    "& .MuiDataGrid-columnsContainer": {
      borderTop: theme.custom.border.primary,
      borderBottom: theme.custom.border.primary,
      "& .MuiDataGrid-iconButtonContainer": {
        marginLeft: theme.spacing(1),
      },
    },
    "& .MuiDataGrid-cellCenter": {
      justifyContent: "center",
    },
    "& .MuiDataGrid-cellRight": {
      justifyContent: "flex-end",
    },
    "& .MuiDataGrid-colCellTitle": {
      fontSize: "12px",
      color: theme.custom.color.mortar,
      fontWeight: 600,
      textTransform: "uppercase",
    },
    "& .MuiDataGrid-cell": {
      fontSize: "14px",
      color: theme.custom.color.blackRussian,
      fontWeight: 400,
      borderBottom: theme.custom.border.primary,
    },
    "& .MuiDataGrid-columnSeparator": {
      color: "rgba(224, 224, 224, 0.5)",
    },
    "& .hideColTitle": {
      "& .MuiDataGrid-colCellTitle": {
        visibility: "hidden",
      },
    },
    "& .hideColSeparator": {
      "& .MuiDataGrid-columnSeparator": {
        visibility: "hidden",
      },
    },
  },
  customRowHeight: {
    "& .MuiDataGrid-renderingZone": {
      maxHeight: "none !important",
    },
    "& .MuiDataGrid-window": {
      "& .MuiDataGrid-row": {
        maxHeight: "none !important",
        "& .MuiDataGrid-cell": {
          lineHeight: "unset !important",
          maxHeight: "none !important",
          whiteSpace: "normal",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: theme.spacing(2, 2),
        },
      },
    },
  },
  compact: {
    "& .MuiDataGrid-cell": {
      padding: theme.spacing(1, 1) + " !important",
    },
  },
  customColumnPanel: {
    display: "flex",
    flex: 1,
    "& .MuiDataGridPanelHeader-root, & .MuiDataGridPanelContent-root, & .MuiDataGridPanelFooter-root":
      {
        padding: theme.spacing(1, 2),
      },
    "& .MuiDataGridPanelContent-root": {
      "& .MuiDataGridColumnsPanel-container": {
        padding: 0,
        "& .MuiFormControlLabel-label ": {
          textTransform: "capitalize",
          fontSize: "14px",
          color: theme.custom.color.blackRussian,
        },
        "& .MuiDataGridColumnsPanel-column:last-child": {
          display: "none",
        },
      },
    },
    "& .MuiDataGridPanelHeader-root .MuiFormControl-root": {
      "& .MuiInputLabel-formControl": {
        color: theme.custom.color.blackRussian,
        opacity: 0.4,
        fontSize: "14px",
      },
      "& .MuiInputLabel-formControl .MuiInputLabel-asterisk": {
        display: "none",
      },
      "& .MuiInputLabel-formControl.Mui-focused": {
        color: theme.palette.primary.main,
        opacity: 1,
      },
      "& .MuiInputBase-root:before": {
        borderColor: theme.custom.color.gainsboro,
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderColor: theme.custom.color.gainsboro,
      },
    },
  },
  customFilterPanel: {
    "& .MuiDataGridFilterForm-root": {
      padding: theme.spacing(1.5, 2),
      "& .MuiFormLabel-root": {
        fontSize: "12px",
        color: theme.custom.color.gainsboro,
      },
      "& .MuiInputBase-root": {
        "& .MuiSelect-root, & .MuiInput-input": {
          fontSize: "14px",
          color: theme.custom.color.blackRussian,
        },
        "&:before": {
          display: "none",
        },
        "& .MuiSelect-root": {
          paddingLeft: theme.spacing(1),
          textTransform: "capitalize",
        },
      },
    },
    "& .MuiDataGridFilterForm-closeIcon": {
      display: "none",
    },
  },
  rowHoverMousePtr: {
    "& .MuiDataGrid-viewport": {
      "& .MuiDataGrid-row:hover": {
        backgroundColor: theme.palette.background.default,
        boxShadow: theme.custom.boxShadow.primary,
        cursor: "pointer",
      },
    },
  },
  paginationBottom: {
    marginTop: theme.spacing(2),
  },
}));
